export const MuiSvgIcon = {
  styleOverrides: {
    root: {
      fontSize: '1.2rem',
    },
  },
}
